export default __webpack_public_path__ + "images/SAML-logo.svg";